import React from "react";
import {
  Typography,
  Card,
  CardContent,
  CardActions,
  makeStyles,
  Paper,
  Avatar,
  Grid,
  Button,
  Divider,
  Box,
  Link,
} from "@material-ui/core";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    background: theme.palette.type === "dark" ? "#000" : "#f5f5f5",
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(3),
    textAlign: "center",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    transition: "transform 0.2s",
    "&:hover": {
      transform: "scale(1.05)",
    },
    backgroundColor: theme.palette.type === "dark" ? "#121212" : "#fafafa",
  },
  avatar: {
    width: theme.spacing(14),
    height: theme.spacing(14),
    marginBottom: theme.spacing(2),
  },
  memberName: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  memberRole: {
    fontSize: "1.2rem",
    color: "#8601af",
    marginBottom: theme.spacing(1),
  },
  memberDescription: {
    fontSize: "1rem",
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  learnMoreButton: {
    color: "#8601af",
    borderColor: "#8601af",
    "&:hover": {
      borderColor: "#8601af",
    },
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  socialIcons: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  socialIcon: {
    color: "#8601af",
    marginLeft: theme.spacing(1),
    "&:hover": {
      color: "#8601af",
    },
  },
}));

const OurTeam = () => {
  const classes = useStyles();

  const teamMembers = [
    {
      name: "Mbalenhle Gcabashe",
      role: "Director",
      description:
        "Mbalenhle Gcabashe is an absolute pleasure to work with. Her ambition and excellent problem-solving abilities make her the best Director NgeMbalenhle Tutoring Services could ask for.",
      image: "/assets/images/mbali.png",
      linkedIn: "https://www.linkedin.com/in/mbalenhle-gcabashe/",
      twitter: "https://twitter.com/mbalenhle",
      facebook: "https://www.facebook.com/mbalenhle",
    },

    // Add more team members here...
  ];

  return (
    <Paper className={classes.container} elevation={3}>
      <Typography variant="h4" className={classes.title}>
        Meet Our Team
      </Typography>
      <Grid
        container
        spacing={3}
        justify={teamMembers.length === 1 ? "center" : "flex-start"}
      >
        {teamMembers.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card className={classes.card}>
              <Avatar
                alt={member.name}
                src={member.image}
                className={classes.avatar}
              />
              <CardContent>
                <Typography variant="h6" className={classes.memberName}>
                  {member.name}
                </Typography>
                <Typography variant="body2" className={classes.memberRole}>
                  {member.role}
                </Typography>
                <Typography
                  variant="body1"
                  className={classes.memberDescription}
                >
                  {member.description}
                </Typography>
                <Box className={classes.socialIcons}>
                  <Link href={member.linkedIn} target="_blank" rel="noreferrer">
                    <LinkedInIcon className={classes.socialIcon} />
                  </Link>
                  <Link href={member.twitter} target="_blank" rel="noreferrer">
                    <TwitterIcon className={classes.socialIcon} />
                  </Link>
                  <Link href={member.facebook} target="_blank" rel="noreferrer">
                    <FacebookIcon className={classes.socialIcon} />
                  </Link>
                </Box>
              </CardContent>
              <Divider className={classes.divider} />
              <CardActions>
                <Button
                  variant="outlined"
                  className={classes.learnMoreButton}
                  fullWidth
                >
                  Learn More
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default OurTeam;
